export default __webpack_public_path__ + "static/media/8.5a0b082e.png";